// extracted by mini-css-extract-plugin
module.exports = {"container":"a2c79c7e7d--container--ALkzX","title":"a2c79c7e7d--title--Az2Cb","description":"a2c79c7e7d--description--esxkA","phone":"a2c79c7e7d--phone--biZa1"};